<template>
  <section id="timeline" class="section">
    <div class="content-wrapper">
      <div class="title-container">
        <h1 class="title">GARIS MASA PROGRAM</h1>
        <p class="disclaimer">
          Masa dan lokasi program tertakluk kepada perubahan mengikut keperluan penganjur. Sebarang perubahan akan dimaklumkan kepada peserta melalui saluran komunikasi rasmi.
        </p>
      </div>
      <div class="timeline-scroll">
        <div class="timeline-events">
          <!-- Februari -->
          <div class="event-card">
            <div class="event-date">
              <span class="date">20<sup>hb</sup> Februari 2025</span>
            </div>
            <div class="event-content">
              <ul>
                <li>Pendaftaran Dibuka</li>
              </ul>
            </div>
          </div>

          <!-- Mac -->
          <div class="event-card">
            <div class="event-date">
              <span class="date">31<sup>hb</sup> Mac 2025</span>
            </div>
            <div class="event-content">
              <ul>
                <li>Pendaftaran Ditutup</li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">7<sup>hb</sup> April 2025</span>
            </div>
            <div class="event-content">
              <ul>
                <li>Surat Setuju Terima Dikeluarkan kepada peserta yang layak</li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">10<sup>hb</sup> April 2025</span>
            </div>
            <div class="event-content">
              <ul>
                <li>Tarikh Akhir untuk maklum balas
                  Surat Setuju Terima</li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">22<sup>hb</sup> April 2025</span>
            </div>
            <div class="event-content">
              <h3>2 petang - 5 petang</h3>
              <ul>
                <li><strong>Modul 1:</strong> <em>Pengenalan kepada Dasar Ekonomi Penjagaan</em></li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">23<sup>hb</sup> April 2025</span>
            </div>
            <div class="event-content">
              <h3>9 pagi - 5 petang</h3>
              <ul>
                <li><strong>Modul 2:</strong> <em>Apa itu Model Kanvas Bisnes?</em></li>
                <li><strong>Kelas Pitching 1</strong> <em>(Kemahiran Asas Pitching)</em></li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">29<sup>hb</sup> April 2025</span>
            </div>
            <div class="event-content">
              <h3>9 pagi - 5 petang</h3>
              <ul>
                <li><strong>Klinik Pitching 1</strong> <em>(Asah Kemahiran Pitch)</em></li>
                <li><strong>Modul 3:</strong> <em>Strategi Branding dalam trend global semasa</em></li>
              </ul>
            </div>
          </div>

          <!-- April -->
          <div class="event-card">
            <div class="event-date">
              <span class="date">30<sup>hb</sup> April 2025</span>
            </div>
            <div class="event-content">
              <h3>9 pagi - 5 petang</h3>
              <ul>
                <li><strong>Kelas Pitching 2</strong> <em>(Membina Pitch Deck Berjaya & Strategi Menarik
                  Pelabur)</em></li>
                <li><strong>Klinik Pitching 2</strong> <em>(Pembentangan Pitch)</em></li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">6<sup>hb</sup> Mei 2025</span>
            </div>
            <div class="event-content">
              <h3>2 petang - 5 petang</h3>
              <ul>
                <li><strong>Business Talk & Networking Event</strong> <em>(Meneroka Horizon Baru: Peluang dan Inovasi dalam Dunia Perniagaan)</em></li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">7<sup>hb</sup> Mei 2025</span>
            </div>
            <div class="event-content">
              <h3>9 pagi - 5 petang</h3>
              <ul>
                <li><strong>Modul 4:</strong> <em>Strategic Fundraising: Bila Duit Tidak Jatuh Dari Langit</em></li>
                <li><strong>Modul 5:</strong> <em>Jaga Duit, Jaga Bisnes</em></li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">15<sup>hb</sup> Mei 2025</span>
            </div>
            <div class="event-content">
              <h3>9 pagi - 5 petang</h3>
              <ul>
                <li><strong>Modul 6:</strong> <em>Strategi Pemasaran Digital</em></li>
                <li><strong>Modul 7:</strong> <em>Data Analitik : Mengumpul, Mentafsir dan Menganalisis data</em></li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">20<sup>hb</sup> Mei 2025</span>
            </div>
            <div class="event-content">
              <h3>9 pagi - 1 petang</h3>
              <ul>
                <li><strong>Lawatan Industri Tempatan</strong></li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">21<sup>hb</sup> Mei 2025</span>
            </div>
            <div class="event-content">
              <h3>9 pagi - 5 petang</h3>
              <ul>
                <li><strong>Klinik Pitching 3</strong> <em>(Simulasi Pitch)</em></li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">27 & 28<sup>hb</sup> Mei 2025</span>
            </div>
            <div class="event-content">
              <ul>
                <li>Pitching (Pusingan Separuh Akhir)</li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">4<sup>hb</sup> Jun 2025</span>
            </div>
            <div class="event-content">
              <ul>
                <li>Pengumuman 10 syarikat yang layak ke peringkat akhir</li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">21<sup>hb</sup> Jun 2025</span>
            </div>
            <div class="event-content">
              <ul>
                <li>Pitching (Peringkat Akhir)</li>
              </ul>
            </div>
          </div>

          <div class="event-card">
            <div class="event-date">
              <span class="date">Julai 2025 ke atas</span>
            </div>
            <div class="event-content">
              <ul>
                <li>Lawatan Industri ke Luar Negara</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TimelineSection',
  mounted() {
    this.initDragScroll();
  },
  methods: {
    initDragScroll() {
      const slider = document.querySelector('.timeline-scroll');
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('dragging');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('dragging');
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('dragging');
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        slider.scrollLeft = scrollLeft - walk;
      });

      // Add touch support
      slider.addEventListener('touchstart', (e) => {
        isDown = true;
        slider.classList.add('dragging');
        startX = e.touches[0].pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('touchend', () => {
        isDown = false;
        slider.classList.remove('dragging');
      });

      slider.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.touches[0].pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      });
    }
  }
}
</script>

<style scoped>
.section {
  padding: 4rem 2rem;
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}

.title-container {
  text-align: center;
  margin-bottom: 0.5rem;
}

.title {
  font-size: 3.5rem;
  color: var(--text-primary);
  line-height: 1.2;
  font-weight: bold;
}

.disclaimer {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  margin-top: 1rem;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.timeline-scroll {
  overflow-x: auto;
  padding: 1rem 0;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  padding: 2rem 1rem;
  scrollbar-width: thin;
  scrollbar-color: var(--primary) var(--background-light);
}

.timeline-events {
  display: flex;
  gap: 2rem;
  padding: 0.5rem;
  min-width: max-content;
}

.event-card {
  background: var(--background-white);
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: 0 4px 6px var(--shadow-color);
  display: flex;
  flex-direction: column;
  min-width: 350px;
  max-width: 350px;
  transition: transform var(--transition-speed) ease;
}

.event-card:hover {
  transform: translateY(-5px);
}

.event-date {
  background: var(--primary);
  color: var(--text-tertiary);
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date {
  font-size: 1.3rem;
  font-weight: bold;
}

.event-content {
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--background-white);
}

.event-content h3 {
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-size: var(--font-size-md);
}

.event-content ul {
  list-style-type: none;
  padding: 0;
}

.event-content li {
  margin-bottom: 0.5rem;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  line-height: 1.4;
}

.timeline-scroll::-webkit-scrollbar {
  height: 12px;
}

.timeline-scroll::-webkit-scrollbar-track {
  background: var(--background-light);
  border-radius: 6px;
}

.timeline-scroll::-webkit-scrollbar-thumb {
  background-color: var(--primary);
  border-radius: 6px;
  border: 3px solid var(--background-light);
}

.timeline-scroll.dragging {
  cursor: grabbing;
  user-select: none;
}

@media (max-width: 768px) {
  .title {
    font-size: 2.5rem;
  }

  .event-card {
    min-width: 280px;
  }
}

.date sup {
  font-size: 0.6em;
  font-weight: normal;
  margin-left: 1px;
}
</style> 